import { AdUnitProvidersConfig } from '@/modules/adv'
import { XIAOMI_TEST_CLID } from '@/modules/main-frame/custom-integrations/xiaomi'
import { AdProviderNames } from '@/types'

type Config = {
    isInitGameScreenHidden?: boolean
    inGameAdUnitProviderConfig?: Partial<AdUnitProvidersConfig<AdProviderNames>> | undefined
    inGameProviderKeys?: AdProviderNames[] | undefined
}

const CONFIG: Record<string, Config> = {
    'p_a68073c6-abde-4a55-a494-5ddb9ec8baa0': {
        isInitGameScreenHidden: true,
        inGameAdUnitProviderConfig: {
            [AdProviderNames.GOOGLE_INSTREAM_CHEAP]: {
                desktop: {
                    interstitial_preroll: 'instream_preroll_no_floor_desktop',
                    interstitial: 'instream_no_floor_desktop',
                    rewarded: 'instream_rewarded_no_floor_desktop',
                },
                mobile: {
                    interstitial_preroll: 'instream_preroll_no_floor_mobile',
                    interstitial: 'instream_no_floor_mobile',
                    rewarded: 'instream_rewarded_no_floor_mobile',
                },
            },
        },
        inGameProviderKeys: [AdProviderNames.GOOGLE_INSTREAM, AdProviderNames.GOOGLE_INSTREAM_CHEAP],
    },
    [XIAOMI_TEST_CLID]: {
        isInitGameScreenHidden: true,
    },
}

export function getConfigByClid(clid: string): Config {
    return CONFIG[clid] || {}
}
